import { render, staticRenderFns } from "./TextImageCard.vue?vue&type=template&id=5abb4be6&scoped=true"
import script from "./TextImageCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TextImageCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TextImageCard.vue?vue&type=style&index=0&id=5abb4be6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb4be6",
  null
  
)

export default component.exports